import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { toast } from "@/lib/toast";
import { MessagesSquare, Loader2 } from "lucide-react";

/**
 * Opens (or reuses) a staff-chat thread about any object and jumps to /admin/team.
 * type: listing | order | dispute | account | report | audit_event
 */
export function DiscussButton({ type, id, label = "Discuss", className = "", compact = false }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const go = async (e) => {
    e?.stopPropagation?.();
    if (!id) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/team/discuss", { type, id });
      navigate(`/admin/team?channel=${data.channel_id}&thread=${data.thread_root_id}`);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={go}
      disabled={busy}
      data-testid={`discuss-btn-${type}-${id}`}
      title="Discuss with the team"
      className={`inline-flex items-center gap-1.5 border border-sniper text-secondary-foreground hover:text-foreground hover:border-olive font-mono uppercase transition-colors disabled:opacity-50 ${compact ? "text-[10px] px-2 py-1" : "text-xs px-3 py-2"} ${className}`}
    >
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <MessagesSquare className="w-3.5 h-3.5" />}
      {label}
    </button>
  );
}

export default DiscussButton;
